import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface StaticServiceCode {
  code: string;
  description: string;
  category: string;
}

@Injectable({
  providedIn: 'root',
})
export class StaticServicesService {
  private apiUrl = `${environment.voiceAPIConfig.uri}/billing/static-services`;

  constructor(private http: HttpClient) {}

  getStaticServiceCodes(): Observable<StaticServiceCode[]> {
    return this.http.get<StaticServiceCode[]>(this.apiUrl);
  }

  checkIfStatic(code: string): Observable<{
    code: string;
    isStatic: boolean;
    info?: StaticServiceCode;
  }> {
    return this.http.get<{
      code: string;
      isStatic: boolean;
      info?: StaticServiceCode;
    }>(`${this.apiUrl}/check/${code}`);
  }
}
